
import Vue from 'vue';
import {Component, Emit, Prop} from 'vue-property-decorator';
import {
  ActionDefinition,
  Board,
  BoardsAPIControllerUIClient,
  Duty,
  SurveyDto,
  SurveyJsUiClient, SurveyView, Ticket
} from '../../backend/backendapi';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import DutyStore from '../../../stores/DutyStore';
import {initClient} from "../../../api";

@Component({
  components: {
    vSelect,
  },
})
export default class DefinitionEditorSurveyResultSpecific extends Vue {
  @Prop({required: true})
  definition!: ActionDefinition;
  @Prop({required: true})
  parsedJsonParameters!: any;

  readonly boardAPI = initClient(BoardsAPIControllerUIClient);
  readonly surveyApi = initClient(SurveyJsUiClient);

  readonly boards: Board[] = [];
  readonly surveys: SurveyView[] = []
  
  get boardId(): number | null {
    return this.parsedJsonParameters.boardId ?? null;
  }

  set boardId(value: number | null) {
    this.parsedJsonParameters.boardId = value;
    this.ticketId = null;
    this.onParsedJsonChanged();
  }

  get name(): string | null {
    return this.parsedJsonParameters.name ?? null;
  }

  set name(value: string | null) {
    this.parsedJsonParameters.name = value;
    this.onParsedJsonChanged();
  }

  get surveyId(): string | null {
    return this.parsedJsonParameters.surveyId ?? null;
  }

  set surveyId(value: string | null) {
    this.parsedJsonParameters.surveyId = value;
    this.onParsedJsonChanged();
  }

  get ticketId(): number | null {
    return this.parsedJsonParameters.ticketId ?? null;
  }

  set ticketId(value: number | null) {
    this.parsedJsonParameters.ticketId = value;

    this.onParsedJsonChanged();
  }

  get tickets(): Ticket[] {
    if (this.boardId === null) {
      return [];
    }

    return this.boards.find(b => b.id == this.boardId)?.tickets ?? [];
  }

  canSaveChanged() {
    this.$nextTick(() => {
      let res = (this.boardId !== null) && (this.ticketId !== null) && (this.name !== null) && (this.name !== "") && (this.surveyId !== null);
      this.$emit("canSaveChanged", res);
    });
  }
  
  async mounted(): Promise<void> {
    await this.reloadBoardData();
    await this.reloadSurveyData();
  }

  onParsedJsonChanged() {
    this.$emit('changed', this.parsedJsonParameters);
    this.canSaveChanged();
  }
  
  async reloadBoardData(): Promise<void> {
    const boards = (await this.boardAPI.list(false, false)).result ?? [];
    this.boards.splice(0);
    this.boards.push(...boards);
  }

  async reloadSurveyData(): Promise<void> {
    const surveys = await this.surveyApi.list();
    this.surveys.splice(0);
    this.surveys.push(...surveys);
  }
}
